<div class="col-md-12 mainDiv">
  <div class="col-md-12 headerDiv">
    <ol class="breadcrumb customBreadCrumb">
      <li>
        <a href="">{{ "global.menu.home" | translate }}</a>
      </li>
      <li>
        <a href="">{{ "global.menu.information" | translate }}</a>
      </li>
      <li class="active">{{ "global.menu.document" | translate }}</li>
    </ol>
    <bs-modal
      id="fundModal"
      #addfundform
      cssClass="addFundModal"
      [hidden]="hideModal"
    >
      <bs-modal-header [showDismiss]="true" class="customModalHeader">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-hidden="true"
        >
          &times;
        </button>
      </bs-modal-header>
      <bs-modal-body>
        <div class="modal-footer">
          <div class="col-md-12 centertext">
            <strong class="centertext"
              >Are you sure you want to delete the document ?</strong
            >
          </div>
          <div class="col-md-4">&nbsp;</div>
          <div class="col-md-2">
            <button
              type="button"
              class="btn btn-default btnsearch"
              data-dismiss="modal"
            >
              No
            </button>
          </div>
          <div class="col-md-2">
            <button
              type="submit"
              class="btn btn-primary btnsearch"
              (click)="deleteDocByCode()"
              data-dismiss="modal"
            >
              Yes
            </button>
          </div>
          <div class="col-md-4">&nbsp;</div>
        </div>
      </bs-modal-body>
    </bs-modal>

    <div class="">
      <div class="row">
        <div class="col-md-3 searchIcon">
          <span class="glyphicon glyphicon-search"></span>
        </div>
        <div class="col-md-5 buttnfreemargin">
          <div class="login-form-group pmi_form_group">
            <input
              type="text"
              id="username"
              name="username"
              [(ngModel)]="searchModel"
              autocomplete="off"
              autofocus
              required
              (keyup)="clearSearchData()"
            />
            <span class="bar"></span>
            <label>{{ "document.searchcaption" | translate }}</label>
          </div>
        </div>
        <div class="col-md-1 clearSearch">
          <button
            type="button"
            class="close customClose"
            aria-label="Close"
            (click)="clearByClose()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="col-md-3"></div>
      </div>
    </div>
    <div id="document_search" style="width: 75%;">
      <div class="row">
        <div class="col-md-3 searchIcon">
          <span class="glyphicon glyphicon-search"></span>
        </div>
        <div class="col-md-5 buttnfreemargin">
          <div class="login-form-group pmi_form_group">
            <div class="form-group">
              <!-- (change)="onSelect($event.target.value)" -->
              <select [(ngModel)]="selectedProductForSearch">
                <option value="0" disabled selected="selected">
                  Please select Document
                </option>
                <option
                  *ngFor="let product of productList"
                  [value]="product.productId"
                >
                  {{ product.productName }}
                </option>
              </select>

              <!-- <select class="d-inline-block" #mySelectedProduct1 (change)="selectProduct(mySelectedProduct1.value)">
                        <option selected disabled value=''>Please select Document</option>
                        <option *ngFor="let product of productList; index as i" [value]="product.productId"> {{product.productName}}</option>
                      </select> -->
            </div>
          </div>
        </div>
        <div class="col-md-1 clearSearch">
          <button
            type="button"
            class="close customClose"
            aria-label="Close"
            (click)="clearBySearchDropdown()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="col-md-3"></div>
      </div>
      <div class="row">
        <div class="col-md-5"></div>
        <div class="col-md-2">
          <button
            (click)="getDocuments()"
            type="button"
            class="btn btn-primary btnsearch"
          >
            {{ "document.search" | translate }}
          </button>
        </div>
        <div class="col-md-5"></div>
      </div>
    </div>
  </div>
  <div class="col-md-12 globbalPadding">
    <div
      class="alert alert-success alert-dismissable centerText"
      *ngIf="success"
    >
      <a class="close" data-dismiss="alert">×</a> Document Uploaded Sucessfully!
    </div>
    <div class="alert alert-danger centerText" *ngIf="error">
      {{ "calculator.pensionCalculator.serverError" | translate }}
    </div>
    <div
      class="col-md-12 alert alert-danger noMargin centerText"
      *ngIf="noTitle"
    >
      Please enter a title and product id for the document upload.
    </div>
    <div class="col-md-12 alert alert-success centerText" *ngIf="deleteSuccess">
      <a class="close" data-dismiss="alert">×</a> Document deleted successfully
    </div>
    <div class="col-md-12 alert alert-error centerText" *ngIf="deleteError">
      {{ "calculator.pensionCalculator.serverError" | translate }}
    </div>
    <div class="col-md-12 alert alert-danger centerText" *ngIf="noFile">
      File not found!
    </div>
  </div>
  <div class="col-md-12 uploadMainDiv" *ngIf="allowUpload">
    <form
      #formCtrl="ngForm"
      name="documentForm"
      enctype="multipart/form-data"
      novalidate
    >
      <div class="row">
        <div class="col-md-2 searchIcon">
          <span class="glyphicon glyphicon-upload"></span>
        </div>
        <div class="col-md-5 buttnfreemargin">
          <div class="login-form-group pmi_form_group">
            <input
              type="text"
              class="doc-search"
              name="docTitle"
              ngControl="docTitleCtrl"
              [(ngModel)]="docTitle"
              autocomplete="off"
              autofocus
              required
            />
            <!--
                          <span class="highlight"></span>
            -->
            <span class="bar"></span>
            <label>{{ "document.documentupload" | translate }}</label>
          </div>
        </div>
        <div class="col-md-1 clearSearch">
          <button
            type="button"
            class="close customClose"
            aria-label="Close"
            (click)="clearUploadTitleData()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="col-md-2"></div>
      </div>
      <div class="row">
        <div class="col-md-3 searchIcon">
          <span class="glyphicon glyphicon-upload"></span>
        </div>
        <div class="col-md-5 buttnfreemargin">
          <div class="login-form-group pmi_form_group">
            <div class="form-group">
              <select
                [(ngModel)]="selectedProductForUpload"
                name="selectedProductForUpload"
              >
                <option value="0" disabled selected="selected">
                  Please Select Document
                </option>
                <option
                  *ngFor="let product of productList"
                  [value]="product.productId"
                >
                  {{ product.productName }}
                </option>
              </select>
              <!-- <select class="d-inline-block" #mySelectedProduct (change)="selectProduct(mySelectedProduct.value)">
                      <option selected disabled value="">Please select Document</option>
                      <option *ngFor="let product of productList; index as i" [value]="product.productId"> {{product.productName}}</option>
                    </select> -->
            </div>
          </div>
        </div>
        <div class="col-md-1 clearSearch">
          <button
            type="button"
            class="close customClose"
            aria-label="Close"
            (click)="clearByUploadDropdown()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="col-md-3">&nbsp;</div>
      </div>
      <div class="row">
        <div class="col-md-2">&nbsp;</div>
        <div class="col-md-2 col-md-offset-3">
          <div class="fileUpload btn btn-primary">
            <span>Upload</span>
            <input
              type="file"
              (change)="onChange($event)"
              required
              class="upload"
              name="attachFile"
              ngControl="fileCtrl"
              [(ngModel)]="attachFile"
              multiple
            />
          </div>
        </div>
        <div class="col-md-3">&nbsp;</div>
      </div>
    </form>
  </div>
  <div class="col-md-12 noBottomMargin">
    <div class="col-md-1 noBottomMargin">&nbsp;</div>
    <div class="col-md-10 tableDiv noBottomMargin">
      <table class="table table-scrollable table-striped documentTable">
        <thead class="gray-thead">
          <tr>
            <th *ngIf="allowUpload">Delete</th>
            <th
              colspan="4"
              class="pointer"
              (click)="sort('fileCaption')"
              [ngClass]="{ sortBg: fileCaptionClass }"
            >
              <span *ngIf="column != 'fileCaption'">
                <span
                  class="glyphicon glyphicon-arrow-up glyphicon-arrow-down upArrow"
                ></span>
                <span class="glyphicon glyphicon-arrow-down downArrow"></span>
              </span>
              <span
                class="sortGlyphicon glyphicon"
                *ngIf="column == 'fileCaption'"
                [ngClass]="{
                  'glyphicon-arrow-up glyphicon-arrow-down':
                    column != 'fileCaption',
                  'glyphicon-arrow-up': column == 'fileCaption' && isDesc,
                  'glyphicon-arrow-down': column == 'fileCaption' && !isDesc
                }"
                aria-hidden="true"
              >
              </span>
              {{ "document.filename" | translate }}
            </th>
            <th
              colspan="2"
              class="pointer"
              (click)="sort('extensionUpper')"
              [ngClass]="{ sortBg: fileExtensionClass }"
            >
              <span *ngIf="column != 'extensionUpper'">
                <span
                  class="glyphicon glyphicon-arrow-up glyphicon-arrow-down upArrow"
                ></span>
                <span class="glyphicon glyphicon-arrow-down downArrow"></span>
              </span>
              <span
                class="sortGlyphicon glyphicon"
                *ngIf="column == 'extensionUpper'"
                [ngClass]="{
                  'glyphicon-arrow-up glyphicon-arrow-down':
                    column != 'extensionUpper',
                  'glyphicon-arrow-up': column == 'extensionUpper' && isDesc,
                  'glyphicon-arrow-down': column == 'extensionUpper' && !isDesc
                }"
                aria-hidden="true"
              >
              </span>
              {{ "document.filetype" | translate }}
            </th>
            <th
              colspan="3"
              class="pointer"
              (click)="sort('fileDate')"
              [ngClass]="{ sortBg: fileDateClass }"
            >
              <span *ngIf="column != 'fileDate'">
                <span
                  class="glyphicon glyphicon-arrow-up glyphicon-arrow-down upArrow"
                ></span>
                <span class="glyphicon glyphicon-arrow-down downArrow"></span>
              </span>
              <span
                class="sortGlyphicon glyphicon"
                *ngIf="column == 'fileDate'"
                [ngClass]="{
                  'glyphicon-arrow-up glyphicon-arrow-down':
                    column != 'fileDate',
                  'glyphicon-arrow-up': column == 'fileDate' && isDesc,
                  'glyphicon-arrow-down': column == 'fileDate' && !isDesc
                }"
                aria-hidden="true"
              >
              </span>
              {{ "document.filedate" | translate }}
            </th>
            <th
              colspan="2"
              class="pointer"
              (click)="sort('fileSize')"
              [ngClass]="{ sortBg: fileSizeClass }"
            >
              <span *ngIf="column != 'fileSize'">
                <span
                  class="glyphicon glyphicon-arrow-up glyphicon-arrow-down upArrow"
                ></span>
                <span class="glyphicon glyphicon-arrow-down downArrow"></span>
              </span>
              <span
                class="sortGlyphicon glyphicon"
                *ngIf="column == 'fileSize'"
                [ngClass]="{
                  'glyphicon-arrow-up glyphicon-arrow-down':
                    column != 'fileSize',
                  'glyphicon-arrow-up': column == 'fileSize' && isDesc,
                  'glyphicon-arrow-down': column == 'fileSize' && !isDesc
                }"
                aria-hidden="true"
              >
              </span>
              {{ "document.filesize" | translate }}
            </th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="showDocs">
            <tr
              *ngFor="
                let doc of data
                  | orderBy : { property: column, direction: direction }
              "
              class="docTr"
            >
              <td colspan="1" *ngIf="allowUpload">
                <input
                  class="docDeleteBox"
                  type="checkbox"
                  name="docCodes"
                  value="{{ doc.docCode }}"
                  (change)="checkDocByCode($event)"
                />
              </td>
              <td colspan="4">
                <a
                  target="_blank"
                  (click)="
                    downloadDocument(
                      doc.docCode,
                      doc.fileCaption,
                      doc.extension
                    )
                  "
                  download="{{ doc.fileName }}"
                  >{{ doc.fileCaption }}</a
                >
              </td>
              <td colspan="2" style="vertical-align: middle; text-align: left">
                <span [ngClass]="doc.class"></span> &nbsp;{{
                  doc.extensionUpper
                }}
              </td>
              <td colspan="3">{{ doc.fileDate }}</td>
              <td colspan="2">{{ doc.fileSize }}</td>
            </tr>
          </ng-container>
          <tr colspan="2" *ngIf="noDocs" class="docTr noData">
            <td colspan="12">
              <b>{{ "global.messages.info.nodata" | translate }}</b>
            </td>
          </tr>
        </tbody>
      </table>
      <pagination
        [directionLinks]="true"
        [boundaryLinks]="true"
        [totalItems]="totalItems"
        [(ngModel)]="currentPage"
        [maxSize]="5"
        previousText="&#8592;"
        nextText="&#8594;"
        firstText="First"
        lastText="&#8677;"
        [rotate]="false"
        (numPages)="($event)"
        (pageChanged)="pageChanged($event)"
      ></pagination>
    </div>
    <div class="col-md-1 noBottomMargin">&nbsp;</div>
    <div class="col-md-9" *ngIf="showCheckBox"></div>
    <div class="col-md-2" *ngIf="showCheckBox">
      <button
        type="button"
        class="btn btn-primary btnsearch"
        data-toggle="modal"
        data-target="#fundModal"
      >
        Delete
      </button>
    </div>
  </div>
</div>
